
import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { useCheckoutStore } from '@/stores/checkoutStore';
import { formatPrice } from '@/lib/utils';
import { AlertCircle, Check } from 'lucide-react';

const DiscountSection = () => {
  const { 
    discountCode, 
    discountApplied,
    discountPercentage,
    finalAmount, 
    loading, 
    error,
    applyDiscount,
    recalculateDiscount
  } = useCheckoutStore();
  
  const [code, setCode] = useState(discountCode || '');
  
  // When component mounts, ensure discount is properly calculated
  useEffect(() => {
    if (discountApplied) {
      recalculateDiscount();
    }
  }, [discountApplied, recalculateDiscount]);
  
  const handleApplyDiscount = async () => {
    if (!code || loading.discount) return;
    await applyDiscount(code);
  };
  
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleApplyDiscount();
    }
  };
  
  return (
    <Card id="discount" className="scroll-mt-24">
      <CardHeader className="pb-3">
        <CardTitle className="text-gray-700">3. Allahindlus</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col space-y-4">
          <div className="flex items-center space-x-2">
            <Input 
              placeholder="Sisesta sooduskood"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              onKeyDown={handleKeyDown}
              disabled={discountApplied || loading.discount}
              className="w-full max-w-xs"
            />
            <Button 
              variant="outline"
              onClick={handleApplyDiscount}
              disabled={!code || discountApplied || loading.discount}
            >
              {loading.discount ? 'Kontrollin...' : 'Rakenda'}
            </Button>
          </div>
          
          {error && !discountApplied && (
            <div className="flex items-center text-sm text-red-600">
              <AlertCircle className="h-4 w-4 mr-1" />
              <span>{error}</span>
            </div>
          )}
          
          {discountApplied && (
            <div className="flex items-center text-sm text-green-600">
              <Check className="h-4 w-4 mr-1" />
              <span>
                Kood rakendatud - {discountPercentage}% allahindlus. Uus hind {formatPrice(finalAmount / 100)} €
              </span>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default DiscountSection;
